/**
 * URL-hash keys for the configurations feature's deep-linkable overlays, bound
 * via `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 */
export const CONFIGURATIONS_HASH = {
  /** `#qr-calculator` — QrSizeCalculatorDialog. */
  qrCalculator: 'qr-calculator'
} as const;

export type ConfigurationsHashKey =
  (typeof CONFIGURATIONS_HASH)[keyof typeof CONFIGURATIONS_HASH];
